import { TextChatMessagesService } from '../text-chat-messages/text-chat-messages.service';
import { Injectable } from '@angular/core';
import { TextChatMessage } from '../xislivechat/models/text-chat-message';
import { DynamicQueryStoreObservableFactory } from 'common/dynamicquery/dynamic-query-store-observable';

@Injectable()
export class TextChatMessagesStoreFactoryService {

  constructor(private textChatMessagesService: TextChatMessagesService,
              private dynamicQueryStoreObservableFactory: DynamicQueryStoreObservableFactory) {
  }

  create(textChatId) {
    if (!textChatId) {
      throw new Error('Missing textChatId');
    }

    const activeTextChats = this.textChatMessagesService.observePastTextChatMessagesByTextChatId(textChatId);
    return this.dynamicQueryStoreObservableFactory.create(activeTextChats, TextChatMessage.comparator);
  }
}
